import { useEffect, useState } from 'react';
// STYLES
import style from '@Components/Planets/planets.module.scss';
import lines from '@Components/Planets/lines.module.scss';

// IMAGES
import _tank from '@Assets/images/tanque.png';
import _lock from '@Assets/images/lock.png';
import tierra from '@Assets/images/planets/tierra.svg';
import { valPackage } from '@Hooks/useValidatePlanet';


export const Tierra = ({ tierraInfo }) => {
  const [skills, setSkills] = useState([
    {
      skill: '',
    },
    {
      skill: '',
    },
    {
      skill: '',
    },
  ]);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('TIERRA');


  const { popup } = valPackage();

  useEffect(() => {
    if (tierraInfo.titulo) {
      setSkills(tierraInfo.skills);
      setDescription(tierraInfo.descripcion);
      setTitle(tierraInfo.titulo);
    }
  }, [tierraInfo]);

  return (
    <div>
      <div className={style.cardItem}>
        <div className={style.card_name_tankItem}>
          <h2>{title}</h2>
          <div className={style.card_tank_value}>
            <label>x3</label>
            <img src={_tank} alt="tank" />
          </div>
        </div>
        <div className={`${style.planetImage_content} ${lines.lines_tierra}`}>
          <div className={lines.lines_tierra_1}>
            <p>{skills[0].skill}</p>
          </div>
          <div className={lines.lines_tierra_2}>
            <p>{skills[1].skill}</p>
          </div>
          <div className={lines.lines_tierra_3}>
            <p>{skills[2].skill}</p>
          </div>
          <img src={_lock} alt="lock" className={style.imgLock} />
          <img src={tierra} alt="planet" className={`${style.planetImage} ${style.tierra}`} />
        </div>
        <div className={style.planetInfo}>
          <p>{description}</p>
        </div>
        <div className={style.planetButton_content}>
              <button className={style.moon_launchBtn} onClick={() => popup()}>
                ACCEDER
              </button>
        </div>
      </div>
    </div>
  );
};
